import { ONE_PLACEHOLDER, ZERO_PLACEHOLDER } from '@/scripts/constants/placeholders'

import { WcsStoreId } from '../wcs/types/store-id'
import { arePricesDifferent } from '@/scripts/libs/price'
import { isProductOpticalOrSun } from '@/scripts/libs/products'
import { sumPrices } from '@/scripts/libs/price'
import wcs from '@/scripts/libs/wcs'

export class KlarnaAfterpay {
  static calculatePrice = (
    productType: string,
    isEyeMedApplied: boolean,
    unformattedTotalFinalPrice: string,
    lensOfferPrice: string,
    lensListPrice: string,
    frameOfferPrice: string,
    frameListPrice: string,
    unformattedPrice: string,
    unformattedOfferPrice: string
  ) => {
    if (isProductOpticalOrSun(productType) && isEyeMedApplied && unformattedTotalFinalPrice) {
      return unformattedTotalFinalPrice
    } else if (isProductOpticalOrSun(productType) && lensListPrice && frameListPrice) {
      const areLensPricesDifferent = arePricesDifferent(lensOfferPrice, lensListPrice)
      const areFramePricesDifferent = arePricesDifferent(frameOfferPrice, frameListPrice)

      if (areLensPricesDifferent && areFramePricesDifferent) {
        return sumPrices(frameOfferPrice, lensOfferPrice)
      } else if (!areLensPricesDifferent && !areFramePricesDifferent) {
        return sumPrices(frameListPrice, lensListPrice)
      } else if (areLensPricesDifferent && !areFramePricesDifferent) {
        return sumPrices(frameListPrice, lensOfferPrice)
      } else if (!areLensPricesDifferent && areFramePricesDifferent) {
        return sumPrices(frameOfferPrice, lensListPrice)
      }
    } else {
      if (unformattedPrice && unformattedOfferPrice) {
        return unformattedOfferPrice
      } else {
        return unformattedPrice || unformattedOfferPrice
      }
    }
  }

  static isAvailableInThisCountry = () => {
    const { storeId } = wcs.getStoreConfig()
    return WcsStoreId.KLARNA_AFTERPAY_COUTRIES.includes(storeId)
  }

  static buildMessage = (
    totalPrice: number,
    instalments: number,
    message: string,
    currency: string
  ) => {
    const dividedPrice = totalPrice / instalments
    const priceToDisplay = `${currency} ${dividedPrice?.toFixed(2)}`
    return message
      ?.replace(ZERO_PLACEHOLDER, `${instalments}`)
      ?.replace(ONE_PLACEHOLDER, priceToDisplay)
  }
}
